import Accordion from 'react-bootstrap/Accordion';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
import FormDevis from './form-devis';


import PropTypes from 'prop-types';

import "../style.css"
import "./accordion.css"


const AccordionBase = (props) => {
	const txtArray = props.titre.split("|");
	const display = txtArray.length > 1 ? <div>{txtArray[0]}|<br className='only_mobile' />{txtArray[1]}</div> : txtArray[0];

	function demandeDevis() {
		const modalComponent = document.createElement("div");
		modalComponent.style.textAlign = "left";
		ReactDOM.render(<FormDevis nomFormation={props.nomFormation} titreFormations={props.titre} />, modalComponent)

		Swal.fire({
			title: 'Demande de devis',
			html: modalComponent,
			showCloseButton: true,
			showCancelButton: false,
			showConfirmButton: false
		})
	}

	const hasInfosRS = Boolean(
		props.intituleRS ||
		props.numeroRS ||
		typeof props.eligibleCPF !== 'undefined' ||
		props.dateDebutParcours ||
		props.dateEcheanceEnregistrement ||
		props.certificateur ||
		(props.arrete && props.arrete !== 'N/A') ||
		props.lienFranceCompetences
	);

	return (
		<Accordion.Item eventKey={props.numberKey} color="primary">
			<Accordion.Header>{display}</Accordion.Header>
			<Accordion.Body>
				<div className="module-cert-box">
					<div className="module-cert-summary">
						<span><strong>Durée :</strong> {props.duree}</span>
						<span><strong>Coût :</strong> {props.prix}</span>
						<span><strong>Taux de réussite :</strong> {/^\d/.test(props.tauxReussite) ? `${props.tauxReussite} %` : props.tauxReussite}</span>
					</div>
					{props.children}
					{hasInfosRS && <>
						<div className="module-cert-title">Informations d'enregistrement au répertoire spécifique</div>
						<dl className="module-cert-grid">
							{props.intituleRS && <>
								<dt>Intitulé :</dt>
								<dd>{props.intituleRS}</dd>
							</>}
							{props.numeroRS && <>
								<dt>Numéro RS :</dt>
								<dd>{props.numeroRS}</dd>
							</>}
							{typeof props.eligibleCPF !== 'undefined' && <>
								<dt>Éligibilité CPF :</dt>
								<dd>{props.eligibleCPF ? 'Éligible' : 'Non éligible'}</dd>
							</>}
							{props.dateDebutParcours && <>
								<dt>Date de début du parcours :</dt>
								<dd>{props.dateDebutParcours}</dd>
							</>}
							{props.dateEcheanceEnregistrement && <>
								<dt>Date d'échéance de l'enregistrement :</dt>
								<dd>{props.dateEcheanceEnregistrement}</dd>
							</>}
							{props.certificateur && <>
								<dt>Certificateur :</dt>
								<dd>{props.certificateur}</dd>
							</>}
							{props.arrete && props.arrete !== 'N/A' && <>
								<dt>Arrêté :</dt>
								<dd>{props.arrete}</dd>
							</>}
						</dl>
						{props.lienFranceCompetences && (
							<a className="module-cert-link" href={props.lienFranceCompetences} target="_blank" rel="noreferrer">
								Voir la fiche sur France Compétences
							</a>
						)}
					</>}
					{!hasInfosRS && <>
						{props.objectif.length > 0 && <div>
							<h5>Objectifs</h5>
							<ul>
								{props.objectif.map((element, index) => (
									<li key={index}>{element}</li>
								))}
							</ul>
						</div>}
						{props.participants.length > 0 && <div>
							<h5>Participants</h5>
							<ul>
								{props.participants.map((element, index) => (
									<li key={index}>{element}</li>
								))}
							</ul>
						</div>}
						{props.preRequis.length > 0 && <div>
							<h5>Pré-requis</h5>
							<ul>
								{props.preRequis.map((element, index) => (
									<li key={index}>{element}</li>
								))}
							</ul>
						</div>}
						{props.programme.length > 0 && <div>
							<h5>Programme</h5>
							<ul>
								{props.programme.map((element, index) => (
									<li key={index}>{element}</li>
								))}
							</ul>
						</div>}
					</>}
				</div>
				{props.recyclage != "" && <div>
					<p>{props.recyclage}</p>
				</div>
				}
				{props.showTraducteurNote && <p>*Si la présence d'un traducteur est jugée nécessaire, le coût de la formation peut varier.</p>}
				<div className='d-flex flex-column flex-sm-row justify-content-center gap-2'>
					{props.programmeLinks.length > 0 ? (
						props.programmeLinks.map((programme, index) => (
							<a key={index} href={`/programmes/${encodeURIComponent(programme.href)}`} target="_blank" rel="noreferrer" className="btn btn-programme mb-2 mt-2">
								{programme.label}
							</a>
						))
					) : props.programmeLink !== "" && (
						<a href={`/programmes/${encodeURIComponent(props.programmeLink)}`} target="_blank" rel="noreferrer" className="btn btn-programme mb-2 mt-2">
							Télécharger le programme
						</a>
					)}
					<button onClick={demandeDevis} className="btn btn-download mb-2 mt-2">Demander un devis</button>
					{props.lienCPF && (
						<a href={props.lienCPF} target="_blank" rel="noreferrer" className="btn btn-download mb-2 mt-2">
							Demander un devis via mon CPF
						</a>
					)}
				</div>
			</Accordion.Body>
		</Accordion.Item>
	);
}

AccordionBase.defaultProps = {
	numberKey: '0',
	titre: '',
	duree: '',
	prix: '',
	tauxReussite: 'N/A',
	objectif: [],
	participants: [],
	preRequis: [],
	programme: [],
	programmeLink: '',
	programmeLinks: [],
	recyclage: '',
	showTraducteurNote: false,
	lienCPF: ''
}

AccordionBase.propTypes = {
	numberKey: PropTypes.string,
	titre: PropTypes.string,
	duree: PropTypes.string,
	tauxReussite: PropTypes.string,
	prix: PropTypes.string,
	objectif: PropTypes.array,
	participants: PropTypes.array,
	preRequis: PropTypes.array,
	programme: PropTypes.array,
	programmeLink: PropTypes.string,
	programmeLinks: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		href: PropTypes.string
	})),
	recyclage: PropTypes.string,
	showTraducteurNote: PropTypes.bool,
	lienCPF: PropTypes.string
}

// Nouveaux props pour les informations d'enregistrement
AccordionBase.defaultProps = Object.assign({}, AccordionBase.defaultProps, {
	numeroRS: '',
	eligibleCPF: undefined,
	dateDebutParcours: '',
	dateEcheanceEnregistrement: '',
	lienFranceCompetences: '',
	arrete: '',
	certificateur: ''
})

AccordionBase.propTypes = Object.assign({}, AccordionBase.propTypes, {
	numeroRS: PropTypes.string,
	eligibleCPF: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	dateDebutParcours: PropTypes.string,
	dateEcheanceEnregistrement: PropTypes.string,
	lienFranceCompetences: PropTypes.string,
	arrete: PropTypes.string,
	certificateur: PropTypes.string
})

export default AccordionBase;